//* *********************************** REACT IMPORTS ************************************
import React from "react";
import { useSelector } from "react-redux";
//* ********************************* EXTERNAL PACKAGES **********************************
import { useTranslation } from "react-i18next";
import NavBar from "../../../components/navbar";

import CEIcon from "../../../assets/images/ce_logo.svg";
import MDIcon from "../../../assets/images/md-icon.svg";
import RXIcon from "../../../assets/images/rx-icon.svg";
import UDIcon from "../../../assets/images/udi.svg";
import SNIcon from "../../../assets/images/sn_logo.svg";
import DMICon from "../../../assets/images/dm-icon.svg";
import ManufacturerIcon from "../../../assets/images/manufacturer.svg";
import InstructionIcon from "../../../assets/images/instruction_logo.svg";
import WarningIcon from "../../../assets/images/warning.svg";
//* *************************************** STYLES ***************************************

//* *********************************** OUR COMPONENTS ***********************************
import { parseDate } from "../../../utils/dataAndTime";
//* ************************************** GLOBALS ***************************************

const CONDITIONS_ID_TO_NAME = {
  1: "Parkinson",
  2: "Depression",
  3: "Sleep Disorders",
  4: "Chronic Low Back Pain",
  5: "Healthy",
  6: "Parkinson Si Buko Uganda",
  7: "Moveable",
  8: "Ulabs_study",
  9: "Care Home",
  10: "Stroke",
  11: "Obesity",
  12: "Frailty",
  13: "Frailty (Provider)",
};

const Privacy = (props) => {
  //* ************************************** SETUP ***************************************
  const { t } = useTranslation();
  const patients = useSelector((state) => state.patients.obj_list);

  const product_version = process.env.REACT_APP_PRODUCT_VERSION;
  const product_date = process.env.REACT_APP_PRODUCT_VERSION_DATE;
  //* ************************************** HANDLERS ************************************

  const openNewWindow = (url) => {
    window.open(url, "_blank");
  };
  //* ************************************** RENDER **************************************

  const getLabelType = (market, conditionId) => {
    if (market === "US") {
      if ([1, 8].includes(conditionId)) return "ClassIIaUS";
      return "ClassIUS";
    } else {
      if ([1, 8].includes(conditionId)) return "ClassIIaEU";
      if (conditionId === 6) return "NonMedicalEU";
      return "ClassIEU";
    }
  };

  const uniqueLabels = {};

  patients.forEach((patient) => {
    const {
      product_market: market,
      medical_conditions: conditions,
      name,
    } = patient;

    conditions.forEach((conditionId) => {
      const labelType = getLabelType(market, conditionId);

      if (!uniqueLabels[labelType]) {
        uniqueLabels[labelType] = {
          patients: [],
          conditionIds: new Set(),
          labelType,
          market,
        };
      }

      uniqueLabels[labelType].patients.push(name);
      uniqueLabels[labelType].conditionIds.add(conditionId);
    });
  });

  const renderLabels = (labelType, market) => {
    const productName =
      labelType === "ClassIIaUS"
        ? "KinetikosMovD (FDA Listed)"
        : labelType === "ClassIUS"
        ? "KinetikOS (Rx Only)"
        : labelType === "ClassIIaEU"
        ? "Kinetikos System"
        : labelType === "NonMedicalEU"
        ? "Parkinson Si Buko Uganda"
        : "KinetikOS";

    const labelData = uniqueLabels[labelType];
    const conditionNames = Array.from(labelData.conditionIds)
      .map((id) => CONDITIONS_ID_TO_NAME[id])
      .filter(Boolean);

    return (
      <div className="d-flex flex-column mb-4" key={`${labelType}-${market}`}>
        <div className="label-header mb-1 fw-bold">{productName}</div>
        {conditionNames.length > 0 && (
          <div className="text-muted text-sm mb-1">
            <p className="label-text">{conditionNames.join(", ")}</p>
          </div>
        )}
        <div className="d-flex flex-row align-items-center justify-content-between">
          <div className="d-flex align-items-start">
            <img src={ManufacturerIcon} alt="Manufacturer Icon" />
            <span className="ms-2 label-text ">
              <strong>Kinetikos Driven Solutions, Lda</strong>
              <br />
              R. Pedro Nunes, Ed. C
              <br />
              3030-199, Coimbra, Portugal
            </span>
          </div>
          <div className='d-flex align-items-center'>
            <img src={DMICon} alt='DM Icon' />
            <span className='ms-2 label-text '>{parseDate(product_date)}</span>
          </div>
          <div className='d-flex'>
            <img src={UDIcon} alt='UDI Icon' />
            <span className='ms-2 label-text '>
              UDI-DI
              <br />
              5600638781828
            </span>
          </div>
          <div className='d-flex'>
            <img src={SNIcon} alt='UDI Icon' />
            <span className='ms-2 label-text '>{product_version}</span>
          </div>
          {labelType === "ClassIIaUS" && (
            <div className='d-flex align-items-center'>
              <span className='ms-2 label-text '>FDA Listed</span>
            </div>
          )}
          {market !== "US" && labelType !== "NonMedicalEU" && (
            <div className='d-flex align-items-center'>
              <img src={CEIcon} alt='CE Icon' />
              <span className='ms-2 label-text '>
                {labelType === "ClassIIaEU" ? "0197" : ""}
              </span>
            </div>
          )}
          {market === "US" && (
            <div className="d-flex align-items-center">
              <span className="ms-2 label-text ">FDA Listed</span>
            </div>
          )}
          {market === "US" && labelType !== "ClassIUS" && (
            <div className="d-flex ">
              <img src={RXIcon} alt="Rx Only Icon" />
            </div>
          )}
          <div className="d-flex">
            {labelType !== "NonMedicalEU" && (
              <img src={MDIcon} alt="Medical Device Icon" />
            )}
            <img
              src={InstructionIcon}
              alt="Instruction Icon"
              className="ms-3"
            />
            <img src={WarningIcon} alt="Warning Icon" className="ms-3" />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className='col profile-body'>
      <NavBar title={t("titles.privacy")} />
      <div className='row profile-privacy mb-5'>
        <div className='privacy-box col-xs-12 col-md-8 col-lg-6 col-xl-4'>
          <span className='title'>{t("titles.terms")}</span>
          <button
            onClick={() => props.history.push("/my_area/privacy/terms_and_conditions")}
            className="primary-button small-wider-button"
          >
            {" "}
            {t("buttons.read")}{" "}
          </button>
        </div>
        <div className='privacy-box col-xs-12 col-md-8 col-lg-6 col-xl-4'>
          <span className='title'>{t("titles.privacy_policy")}</span>
          <button
            onClick={() => props.history.push("/my_area/privacy/privacy_policy")}
            className="primary-button small-wider-button"
          >
            {t("buttons.read")}
          </button>
        </div>
        <div className='privacy-box col-xs-12 col-md-8 col-lg-6 col-xl-4'>
          <span className='title'>{t("titles.about")}</span>
          <button
            onClick={() => openNewWindow("https://www.kinetikoshealth.com/about")}
            className="primary-button small-wider-button"
          >
            {" "}
            {t("buttons.read")}{" "}
          </button>
        </div>
        <div className="privacy-box col-xs-12 col-md-8 col-lg-6 col-xl-4">
          <span className="title">{t("titles.user_manual")}</span>
          <button
            onClick={() =>
              openNewWindow(
                `${process.env.REACT_APP_BACKEND_URL}/cdss/manuals/kinetikos_platform_manual/`
              )
            }
            className='primary-button small-wider-button'
          >
            {" "}
            {t("buttons.read")}{" "}
          </button>
        </div>
      </div>
      <div className='label-footer'>
        <div className='text-center mt-6'>
          <span className='label-text abel-text'>2024 © Kinetikos</span>
        </div>
        <div className='label-sections'>
          {Object.keys(uniqueLabels).map((key) => {
            const { labelType, market } = uniqueLabels[key];
            return renderLabels(labelType, market);
          })}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Privacy);
